import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "inner-main-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "revenue-progress-roadmap-area" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6 col-xxl-6" }
const _hoisted_7 = { class: "col-lg-6 col-xxl-6" }
const _hoisted_8 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center",
  style: {"height":"20vh"}
}

import { onMounted } from "vue";
import DailySummary from "../../components/Dashboard/DailySummary.vue"
import WeeklyChart from "../../components/Dashboard/WeeklyChart.vue"
import AgencySummary from "../../components/Dashboard/AgencySummary.vue"
import LatestReceipts from "../../components/Dashboard/LatestReceipts.vue"
import MainFooter from "../../components/Layouts/MainFooter.vue"
import { useDashboardStore } from '@/stores/dashboard'
import { storeToRefs } from "pinia"
import type { ApiResult } from "@/types/auth"


export default /*@__PURE__*/_defineComponent({
  __name: 'ReceiptSummaryPage',
  setup(__props) {

const { dailyCount, dashboardSummary } = useDashboardStore()
const { error } = storeToRefs(useDashboardStore())

console.log(error.value)

onMounted(async () => {
  const response: ApiResult = await dailyCount()
  if (response.success) {
    dashboardSummary()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_unref(error))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(DailySummary),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(WeeklyChart)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(AgencySummary)
                ])
              ])
            ]),
            _createVNode(LatestReceipts)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("h6", null, "Your account was accessed from another device. Only one active session is allowed at a time.", -1)
          ]))])),
      _createVNode(MainFooter)
    ])
  ]))
}
}

})